import angular from "angular";

class SignupValidate {
  constructor($validation) {
    this.$validation = $validation;
  }

  validate(vm) {
    let valid = true;

    const validator = this;

    vm.result.status = "";
    vm.result.message = "";

    const validFirstName = validator.firstName(vm.first_name, vm);
    const validLastName = validator.lastName(vm.last_name, vm);
    const validCompanyName = validator.companyName(vm.company_name, vm);
    const validEmail = validator.email(vm.email, vm);
    const validPhone = validator.phone(vm.phone_number, vm);
    const validPassword = validator.password(vm.password, vm);

    if (!validCompanyName || !validEmail || !validPhone || !validPassword) {
      valid = false;
      vm.result.status = "error";
    }

    // if (!vm.check_policy) {
    //     valid = false;
    //     vm.result.status  = "error";
    //     vm.result.message = "Please agree with Jobble Terms.";
    // }

    return valid;
  }

  validateJobbler(vm) {
    let valid = true;

    const validator = this;

    vm.result.status = "";
    vm.result.message = "";

    const validEmail = validator.email(vm.email, vm);
    const validPassword = validator.password(vm.password, vm);

    if (!validEmail || !validPassword) {
      valid = false;
      vm.result.status = "error";
    }

    return valid;
  }

  validateField(field, value, validateMethod, constructError, vm) {
    const {isValid, errors} = validateMethod(value);

    if (vm && vm.setValidation)
      vm.setValidation({
        field,
        valid: isValid,
        message: constructError(errors),
      });

    return isValid;
  }

  handleGenericChange(name, value, errorCode, vm) {
    const {CommonValidator} = this.$validation;
    return this.validateField(
      name,
      value,
      (v) => ({
        isValid: CommonValidator.exists(v),
        errors: CommonValidator.exists(v),
      }),
      (valid) => (!valid ? CommonValidator.constructErrorMessage([errorCode]) : ""),
      vm
    );
  }

  firstName(first_name, vm) {
    const {
      Errors: {COMMON_ERRORS},
    } = this.$validation;
    return this.handleGenericChange("first_name", first_name, COMMON_ERRORS.MISSING_FIRST_NAME, vm);
  }

  lastName(last_name, vm) {
    const {
      Errors: {COMMON_ERRORS},
    } = this.$validation;
    return this.handleGenericChange("last_name", last_name, COMMON_ERRORS.MISSING_LAST_NAME, vm);
  }

  companyName(company_name, vm) {
    const {
      Errors: {COMMON_ERRORS},
    } = this.$validation;
    return this.handleGenericChange("company_name", company_name, COMMON_ERRORS.MISSING_COMPANY_NAME, vm);
  }

  phone(phone_number, vm) {
    const {PhoneValidator} = this.$validation;
    if (vm.userInvited && !phone_number) {
      return true;
    }
    return this.validateField("phone", phone_number, PhoneValidator.validatePhone, PhoneValidator.constructErrorMessage, vm);
  }

  zip_code(zip_code, vm) {
    const {ZipValidator} = this.$validation;
    return this.validateField("zip_code", zip_code, ZipValidator.validateZip, ZipValidator.constructErrorMessage, vm);
  }

  email(email, vm) {
    const {EmailValidator} = this.$validation;
    return this.validateField("email", email, EmailValidator.validateEmail, EmailValidator.constructErrorMessage, vm);
  }

  password(password, vm) {
    const {PasswordValidator} = this.$validation;
    return this.validateField("password", password, PasswordValidator.validatePassword, PasswordValidator.constructErrorMessage, vm);
  }
}

SignupValidate.$inject = ["validation"];

export default SignupValidate;



// WEBPACK FOOTER //
// ./client/app/scenes/signup/services/signup.validate.js